// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.10-13140(ddee3864a7)-C10/08/2026-14:52:20-B10/08/2026-14:58:48' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.10-13140(ddee3864a7)-C10/08/2026-14:52:20-B10/08/2026-14:58:48",
  branch: "production",
  latestTag: "8.0.10",
  revCount: "13140",
  shortHash: "ddee3864a7",
  longHash: "ddee3864a7e29b9729ecd7a265f902934f13e163",
  dateCommit: "10/08/2026-14:52:20",
  dateBuild: "10/08/2026-14:58:48",
  buildType: "Ansible",
  } ;
